import QuestionViewStatement from "./QuestionViewStatement";

export default class QuestionViewStatementFraction extends QuestionViewStatement {
    constructor(question) {
        super(question);
    }

    isCorrect() {
        return this._inputValue.toString() === this._question.answer.toString();
    }
}